import lessRequire from '../../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import classname from 'classname';
import { Link } from 'react-router';

import { scrollObservable } from './fixed-head';
import ColumnControl from '../../column-control/main';

import { notFound } from '../../../../shared/table-helpers';
import { formatMoney } from '../../../../shared/format';
import { makeStatisticQuery } from '../../../shared/utils';

import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';
import find from 'lodash/find';
import capitalize from 'lodash/capitalize';
import merge from 'lodash/merge';

lessRequire('modules/statistics/components/table/general/main.less');

const Table = props => {
	const { dataTable, sortByColumn, sortByGroup, intl } = props;
	const {
		columnControlConfig,
		columnControlToggle,
		columnControlApply,
		columnControlReset,
		columnControlDispatchFormAction
	} = props;

	scrollObservable('statistic-table');

	return (
		<table className="statistic-table">
			<Thead data={dataTable} sortByColumn={sortByColumn} sortByGroup={sortByGroup} intl={intl} isFixedHeader={true} />
			<Thead
				data={dataTable}
				sortByColumn={sortByColumn}
				sortByGroup={sortByGroup}
				intl={intl}
				columnControlConfig={columnControlConfig}
				columnControlDispatchFormAction={columnControlDispatchFormAction}
				onColumnControlToggle={columnControlToggle}
				onColumnControlApply={columnControlApply}
				onColumnControlReset={columnControlReset}
			/>

			<tbody className="table__body">
				{rows(dataTable, intl)}
			</tbody>
		</table>
	);
};

Table.propTypes = {
	dataTable: PropTypes.object,
	sortByColumn: PropTypes.func,
	sortByGroup: PropTypes.func,
	columnControlConfig: PropTypes.object,
	columnControlToggle: PropTypes.func,
	columnControlApply: PropTypes.func,
	columnControlReset: PropTypes.func,
	columnControlDispatchFormAction: PropTypes.func,
	intl: PropTypes.func
};

export default Table;

const Thead = ({
	data,
	sortByColumn,
	sortByGroup,
	intl,
	isFixedHeader,
	columnControlConfig,
	onColumnControlToggle,
	onColumnControlApply,
	onColumnControlReset,
	columnControlDispatchFormAction
}) => {
	const { groups, shouldShowGroupHeader, parentColumn, childColumn, currentSorting } = data;
	const rowSpan = shouldShowGroupHeader ? 1 : 2;
	const groupHeaderClass = {
		'group-header': true,
		'font-proxima-nova-semibold': true,
		active: !currentSorting
	};

	const firstGroupHeaderClass = classname({
		...groupHeaderClass,
		first: !!shouldShowGroupHeader,
		'ordered ordered-desc': groups[0]['direction'] === 'desc',
		'ordered ordered-asc': groups[0]['direction'] === 'asc'
	});

	const secondGroupHeaderClass =
		shouldShowGroupHeader &&
		classname({
			...groupHeaderClass,
			'ordered ordered-desc': groups[1]['direction'] === 'desc',
			'ordered ordered-asc': groups[1]['direction'] === 'asc'
		});

	const theadClass = classname({
		table__head: true,
		'table__head-fixed': isFixedHeader
	});

	const dataWidthAttr = isFixedHeader ? { 'data-add-width': true } : { 'data-get-width': true };

	return (
		<thead className={theadClass} id={isFixedHeader ? 'fixed-head' : null}>
			{!isFixedHeader &&
				<tr className="table__head-top font-proxima-nova-semibold">
					<th rowSpan={rowSpan} className={firstGroupHeaderClass} {...dataWidthAttr}>
						<span className="sort-header" onClick={sortByGroup.bind(null, groups[0]['id'])}>
							{groups[0]['title']}
						</span>
					</th>

					{parentColumn('traffic').shouldShow &&
						<th colSpan={parentColumn('traffic').colSpan} className="cell-bg">
							<span>{intl('Трафик')}</span>

							<ColumnControl
								config={columnControlConfig['traffic']}
								dispatchFormAction={columnControlDispatchFormAction}
								onToggle={onColumnControlToggle}
								onApply={onColumnControlApply}
								onReset={onColumnControlReset}
								intl={intl}
							/>
						</th>}

					{parentColumn('conversions').shouldShow &&
						<th colSpan={parentColumn('conversions').colSpan} className="">
							<span>{intl('Конверсии')}</span>

							<ColumnControl
								config={columnControlConfig['conversions']}
								dispatchFormAction={columnControlDispatchFormAction}
								onToggle={onColumnControlToggle}
								onApply={onColumnControlApply}
								onReset={onColumnControlReset}
								intl={intl}
							/>
						</th>}

					{parentColumn('coefficients').shouldShow &&
						<th colSpan={parentColumn('coefficients').colSpan} className="cell-bg">
							<span>{intl('Коэффициенты')}</span>

							<ColumnControl
								config={columnControlConfig['coefficients']}
								dispatchFormAction={columnControlDispatchFormAction}
								onToggle={onColumnControlToggle}
								onApply={onColumnControlApply}
								onReset={onColumnControlReset}
								intl={intl}
							/>
						</th>}

					{parentColumn('revenue').shouldShow &&
						<th colSpan={parentColumn('revenue').colSpan} className="">
							<span>{intl('Доход')}</span>

							<ColumnControl
								config={columnControlConfig['revenue']}
								dispatchFormAction={columnControlDispatchFormAction}
								onToggle={onColumnControlToggle}
								onApply={onColumnControlApply}
								onReset={onColumnControlReset}
								intl={intl}
							/>
						</th>}
				</tr>}

			<tr className="table__head-bottom">
				{!isFixedHeader &&
					shouldShowGroupHeader &&
					<th className={secondGroupHeaderClass}>
						<span className="sort-header" onClick={sortByGroup.bind(null, groups[1]['id'])}>
							{groups[1]['title']}
						</span>
					</th>}
				{isFixedHeader &&
					<th rowSpan={rowSpan} className={firstGroupHeaderClass} {...dataWidthAttr}>
						<span className="sort-header" onClick={sortByGroup.bind(null, groups[0]['id'])}>
							{groups[0]['title']}
						</span>
					</th>}
				{childColumn('hosts').shouldShow &&
					<th className={childColumn('hosts').className} {...dataWidthAttr}>
						<span
							className={getClassesForSortable('', 'hosts', currentSorting)}
							onClick={sortByColumn.bind(null, 'hosts')}
						>
							{intl('Хосты')}
						</span>
					</th>}
				{childColumn('hits').shouldShow &&
					<th className={childColumn('hits').className} {...dataWidthAttr}>
						<span
							className={getClassesForSortable('', 'hits', currentSorting)}
							onClick={sortByColumn.bind(null, 'hits')}
						>
							{intl('Хиты')}
						</span>
					</th>}
				{childColumn('transitions').shouldShow &&
					<th
						className={['font-proxima-nova', 'cell-improve-padding', [childColumn('transitions').className]].join(' ')}
						{...dataWidthAttr}
					>
						<span
							className={getClassesForSortable('', 'transitions', currentSorting)}
							onClick={sortByColumn.bind(null, 'transitions')}
						>
							Т<span className="arrow-right" />{intl('Л')}
						</span>
					</th>}

				{childColumn('accepted_conversions').shouldShow &&
					<th className={childColumn('accepted_conversions').className} {...dataWidthAttr}>
						<span
							className={getClassesForSortable('icon-green', 'accepted_conversions', currentSorting)}
							onClick={sortByColumn.bind(null, 'accepted_conversions')}
						/>
					</th>}
				{childColumn('pending_conversions').shouldShow &&
					<th className={childColumn('pending_conversions').className} {...dataWidthAttr}>
						<span
							className={getClassesForSortable('icon-hold', 'pending_conversions', currentSorting)}
							onClick={sortByColumn.bind(null, 'pending_conversions')}
						/>
					</th>}
				{childColumn('declined_conversions').shouldShow &&
					<th className={childColumn('declined_conversions').className} {...dataWidthAttr}>
						<span
							className={getClassesForSortable('icon-cancel', 'declined_conversions', currentSorting)}
							onClick={sortByColumn.bind(null, 'declined_conversions')}
						/>
					</th>}
				{childColumn('total_conversions').shouldShow &&
					<th
						className={['cell-improve-padding', [childColumn('total_conversions').className]].join(' ')}
						{...dataWidthAttr}
					>
						<span
							className={getClassesForSortable('icon-total', 'total_conversions', currentSorting)}
							onClick={sortByColumn.bind(null, 'total_conversions')}
						/>
					</th>}
				{childColumn('invalid_conversions').shouldShow &&
					<th
						className={['cell-border-left cell-improve-padding', [childColumn('invalid_conversions').className]].join(
							' '
						)}
						{...dataWidthAttr}
					>
						<span
							className={getClassesForSortable('icon-block', 'invalid_conversions', currentSorting)}
							onClick={sortByColumn.bind(null, 'invalid_conversions')}
						/>
					</th>}
				{childColumn('epc').shouldShow &&
					<th className={childColumn('epc').className} {...dataWidthAttr}>
						<span className={getClassesForSortable('', 'epc', currentSorting)} onClick={sortByColumn.bind(null, 'epc')}>
							EPC
						</span>
					</th>}
				{childColumn('crs').shouldShow &&
					<th className={childColumn('crs').className} {...dataWidthAttr}>
						<span className={getClassesForSortable('', 'crs', currentSorting)} onClick={sortByColumn.bind(null, 'crs')}>
							CRS%
						</span>
					</th>}
				{childColumn('crl').shouldShow &&
					<th className={childColumn('crl').className} {...dataWidthAttr}>
						<span className={getClassesForSortable('', 'crl', currentSorting)} onClick={sortByColumn.bind(null, 'crl')}>
							CRL%
						</span>
					</th>}
				{childColumn('approve').shouldShow &&
					<th className={['cell-improve-padding', [childColumn('approve').className]].join(' ')} {...dataWidthAttr}>
						<span
							className={getClassesForSortable('', 'approve', currentSorting)}
							onClick={sortByColumn.bind(null, 'approve')}
						>
							App.%
						</span>
					</th>}

				{childColumn('accepted_income').shouldShow &&
					<th {...dataWidthAttr}>
						<span
							className={getClassesForSortable('icon-green', 'accepted_income', currentSorting)}
							onClick={sortByColumn.bind(null, 'accepted_income')}
						/>
					</th>}
				{childColumn('pending_income').shouldShow &&
					<th {...dataWidthAttr}>
						<span
							className={getClassesForSortable('icon-hold', 'pending_income', currentSorting)}
							onClick={sortByColumn.bind(null, 'pending_income')}
						/>
					</th>}
				{childColumn('declined_income').shouldShow &&
					<th className="cell-padding-right" {...dataWidthAttr}>
						<span
							className={getClassesForSortable('icon-cancel', 'declined_income', currentSorting)}
							onClick={sortByColumn.bind(null, 'declined_income')}
						/>
					</th>}
				{childColumn('bonus').shouldShow &&
					<th className="cell-padding-right cell-border-left" {...dataWidthAttr}>
						<span onClick={sortByColumn.bind(null, 'bonus')}>
							{intl('Бонус')}
						</span>
					</th>}
			</tr>
		</thead>
	);
};

Thead.propTypes = {
	data: PropTypes.object,
	sortByColumn: PropTypes.func,
	sortByGroup: PropTypes.func,
	isFixedHeader: PropTypes.bool,
	columnControlConfig: PropTypes.object,
	onColumnControlToggle: PropTypes.func,
	onColumnControlApply: PropTypes.func,
	onColumnControlReset: PropTypes.func,
	columnControlDispatchFormAction: PropTypes.func,
	intl: PropTypes.func
};

const rows = (dataTable, intl) => {
	const {
		groups, tableRows, shouldShowGroupHeader, childColumn, columnsConfig, dow, dataForGoalsQuery
	} = dataTable;
	let elements = [];
	let shouldShowBonus = childColumn('bonus').shouldShow;

	if (isEmpty(tableRows)) {
		elements.push(notFound(intl, shouldShowBonus ? 17 : 16));
	} else {
		for (let [key, value] of tableRows) {
			shouldShowGroupHeader &&
				key !== 'total' &&
				elements.push(groupHeader(key, groups[0], dow, intl, shouldShowBonus));

			elements.push(
				value.length
					? value.map((row, index) =>
						groupRow(
							row,
							index,
							groups,
							shouldShowGroupHeader,
							childColumn,
							columnsConfig,
							dataForGoalsQuery,
							dow,
							intl
						)
					)
					: notFound(intl)
			);
		}
	}

	return elements;
};

const groupHeader = (title, group, dow, intl, shouldShowBonus) => {
	const value = getGroupText(title, group['id'], dow, intl) || 'Нет данных';
	return (
		<tr key={title} className="header-row">
			<th colSpan={shouldShowBonus ? 17 : 16}>
				<div className="header-row__wrap">
					<span className="header-row__wrap-title font-proxima-nova-semibold">
						{value}
					</span>
					<span className="header-row__wrap-icon" />
				</div>
			</th>
		</tr>
	);
};

const groupRow = (
	row,
	index,
	groups,
	shouldShowGroupHeader,
	childColumn,
	columnsConfig,
	dataForGoalsQuery,
	dow,
	intl
) => {
	let config = {};

	for (let key in columnsConfig) {
		config[key] = childColumn(key);
	}

	const isTotalRow = row.isTotal;

	const makeQueryToGoals = queryToGoals(dataForGoalsQuery, row);
	const { conversionStatuses } = dataForGoalsQuery;

	const approvedStatus = find(conversionStatuses, { id: 'approved' });
	const rejectedStatus = find(conversionStatuses, { id: 'rejected' });
	const pendingStatus = find(conversionStatuses, { id: 'pending' });
	const trashStatus = find(conversionStatuses, { id: 'trash' });
	const currentConversionDate = row.date ? moment(row.date).format('YYYY-MM-DD') : '-';
	return (
		<tr
			key={index}
			className={isTotalRow ? 'total-row hover-active font-open-sans-semibold ' : 'hover-active font-open-sans-regular'}
		>
			{!isTotalRow &&
				<td
					className={
						shouldShowGroupHeader
							? 'group two-group cell-border-right font-proxima-nova-regular'
							: 'group one-group cell-border-right'
					}
				>
					<span>
						{shouldShowGroupHeader
							? getGroupText(row[groups[1]['id']], groups[1]['id'], dow, intl)
							: getGroupText(row[groups[0]['id']], groups[0]['id'], dow, intl)}
					</span>
				</td>}

			{isTotalRow &&
				<td
					className={classname({
						'total-row cell-border-right font-proxima-nova-regular': true,
						'total-row__two-group ': shouldShowGroupHeader
					})}
				>
					{intl('Всего')}
				</td>}

			{config.hosts.shouldShow &&
				<td className={config.hosts.className}><span className="grey">{formatBreakToHundreds(row.hosts)}</span></td>}

			{config.hits.shouldShow &&
				<td className={config.hits.className}><span className="grey">{formatBreakToHundreds(row.hits)}</span></td>}

			{config.transitions.shouldShow &&
				<td className={config.transitions.className}>
					<span>
						<span className="grey">
							{isFinite(row.transitions) ? formatBreakToHundreds(row.transitions) : <i>—</i>}
						</span>
						<span className="percents">{formatTL(row) || <i>—</i>}</span>
					</span>
				</td>}

			{config.accepted_conversions.shouldShow &&
				<td className={['link', [config.accepted_conversions.className]].join(' ')}>
					{isNull(makeQueryToGoals)
						? <span className="green">
							{formatBreakToHundreds(row.accepted_conversions)}
							{' '}
						</span>
						: <Link to={`statistics/conversions?${
							makeQueryToGoals([approvedStatus], !isTotalRow && currentConversionDate)
						}`}
						className="green">
							<i>{formatBreakToHundreds(row.accepted_conversions)}</i>
						</Link>}
				</td>}
			{config.pending_conversions.shouldShow &&
				<td className={['link', [config.pending_conversions.className]].join(' ')}>
					{isNull(makeQueryToGoals)
						? <span>
							{formatBreakToHundreds(row.pending_conversions)}
							{' '}
						</span>
						: <Link to={`statistics/conversions?${
							makeQueryToGoals([pendingStatus], !isTotalRow && currentConversionDate)
						}`}
						className="black">
							<i>{formatBreakToHundreds(row.pending_conversions)}</i>
						</Link>}
				</td>}
			{config.declined_conversions.shouldShow &&
				<td className={['link', [config.declined_conversions.className]].join(' ')}>
					{isNull(makeQueryToGoals)
						? <span>
							{formatBreakToHundreds(row.declined_conversions)}
							{' '}
						</span>
						: <Link to={`statistics/conversions?${makeQueryToGoals(
							[rejectedStatus], !isTotalRow && currentConversionDate
						)}`}
						className="black">
							<i>{formatBreakToHundreds(row.declined_conversions)}</i>
						</Link>}
				</td>}
			{config.total_conversions.shouldShow &&
				<td className={['link cell-improve-padding', [config.total_conversions.className]].join(' ')}>
					{isNull(makeQueryToGoals)
						? <span>
							{formatBreakToHundreds(row.total_conversions)}
							{' '}
						</span>
						: <Link
							to={`statistics/conversions?${
								makeQueryToGoals([approvedStatus, pendingStatus, rejectedStatus],
									!isTotalRow && currentConversionDate)
							}`}
							className="black"
						>
							<i>{formatBreakToHundreds(row.total_conversions)}</i>
						</Link>}
				</td>}
			{config.invalid_conversions.shouldShow &&
				<td
					className={[
						'cell-border-left cell-border-right link invalid-conversions',
						[config.invalid_conversions.className]
					].join(' ')}
				>
					{isNull(makeQueryToGoals)
						? <span>
							{formatBreakToHundreds(row.invalid_conversions)}
							{' '}
						</span>
						: <Link to={`statistics/conversions?${
							makeQueryToGoals([trashStatus], !isTotalRow && currentConversionDate)
						}`}
						className="black invalid-percents">
							<i>{formatBreakToHundreds(row.invalid_conversions)}</i>
							<i className='percents'>{calculatePercent(row)}%</i>
						</Link>}
				</td>}

			{config.epc.shouldShow &&
				<td className={config.epc.className}>
					<span className="grey">{nullIfLargeCRL(row.epc, row.crl) || '-'}</span>
				</td>}
			{config.crs.shouldShow &&
				<td className={config.crs.className}>
					<span className="grey">{nullIfLargeCRL(row.crs, row.crl) || '-'}</span>
				</td>}
			{config.crl.shouldShow &&
				<td className={config.crl.className}>
					<span className="grey">{nullIfLargeCRL(row.crl, row.crl) || '-'}</span>
				</td>}
			{config.approve.shouldShow &&
				<td className={config.approve.className}>
					<span className="grey">
						{
							row.approve ?
								Math.round(parseFloat(row.approve) || 0) :
								<i>—</i>
						}
					</span>
				</td>}

			{config.accepted_income.shouldShow && <td><span className="green">{numFormatter(row.accepted_income)}</span></td>}
			{config.pending_income.shouldShow && <td><span className="grey">{numFormatter(row.pending_income)}</span></td>}
			{config.declined_income.shouldShow && <td><span className="grey">{numFormatter(row.declined_income)}</span></td>}
			{config.bonus.shouldShow &&
				<td className="cell-border-left"><span className="grey">{numFormatter(row.bonus)}</span></td>
			}
		</tr>
	);
};

const nullIfLargeCRL = (number, crl) => {
	return !isNaN(crl) && parseInt(crl) <= 100 ? number : null;
};

const numFormatter = number => formatMoney(number, true);

const formatTL = row => {
	const hasPercents = !!parseInt(row.transitions);
	return hasPercents
		? isFinite(row.transitions / row.hits) ? (row.transitions / row.hits * 100).toFixed(0) + '%' : null
		: '0%';
};

const getClassesForSortable = (className = '', index, currentSortIndex) => {
	return `${className}${index == currentSortIndex ? ' active' : ''}`;
};

const queryToGoals = (dataForGoalsQuery, row) => {
	if (!row) {
		return null;
	}
	const { queryContext, groupColumns } = dataForGoalsQuery;

	return (includedConversionStatuses, filterByThisDate) => {
		const groupFilters = addFiltersByGroups(
			filterByThisDate ? {
				...queryContext,
				date_range: {
					start: `${filterByThisDate} 00:00:00.000`,
					end: `${filterByThisDate} 23:59:59.999`
				}
			}:queryContext,
			groupColumns,
			row
		);

		return makeStatisticQuery(
			merge(
				{},
				queryContext,
				{
					filters: {
						statuses: includedConversionStatuses
					}
				},
				groupFilters
			)
		);
	};
};

const addFiltersByGroups = (queryContext, groupColumns, row) => {
	const result = {
		filters: {}
	};

	const getFilterValueFromCell = (cell, group) => {
		let res;
		if (typeof cell !== 'string') {
			return res;
		}

		let parenthIndex = cell.lastIndexOf('(');

		if (parenthIndex !== -1) {
			let text = cell.substring(0, parenthIndex) && cell.substring(0, parenthIndex).trim();
			let id = cell.substring(parenthIndex);
			id = id && id.replace('(', '').replace(')', '');
			res = [{ id, text }];
		}

		if (group.indexOf('sid') !== -1) {
			res = [{ id: cell, text: cell }];
		}

		if (group === 'traffic_type') {
			res = [{ id: cell, text: capitalize(cell) }];
		}

		if (group === 'status_changed_at') {
			res = [{ id: cell, text: cell }];
		}

		return res;
	};

	queryContext.groups.forEach(group => {
		let relation = groupColumns[group] && groupColumns[group].relationToFilter;

		if (relation && row[group]) {
			result.filters[relation] = getFilterValueFromCell(row[group], group);
		}

		if (group === 'date') {
			result['date_range'] = row.dateRange || queryContext.date_range;
		}
	});

	return result;
};

const getGroupText = (rowValue, group, dow, intl) => {
	switch (group) {
		case 'date':
			return rowValue ? moment(rowValue).format('DD.MM.YYYY') : '-';
		case 'dow':
			return !isNull(rowValue) ? capitalize(intl(dow[rowValue])) : '-';
		case 'hour':
			return !(isUndefined(rowValue) || isNull(rowValue)) ? `${rowValue}:00 - ${++rowValue}:00` : '-';
		case 'traffic_type':
		case 'campaign_type':
			return rowValue ? capitalize(intl(rowValue)) : '-';
		default:
			return rowValue ? stripParensFromGroupHeader(rowValue) : '-';
	}
};

const stripParensFromGroupHeader = (val, group) => {
	val = String(val);
	let parenIndex = val.lastIndexOf('(');
	if (parenIndex === -1) {
		return val;
	}
	return val.slice(0, parenIndex);
};

const formatBreakToHundreds = value => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');

const calculatePercent = row => {
	const percent = (Number(row.invalid_conversions) + Number(row.total_conversions)) / 100;
	const total = Number(row.invalid_conversions) / percent;

	return isNaN(total) ? 0 : total.toFixed(0);
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/table/general/main.js